import { render, staticRenderFns } from "./PrintFooter.vue?vue&type=template&id=3faf51e6&scoped=true&"
import script from "./PrintFooter.vue?vue&type=script&lang=js&"
export * from "./PrintFooter.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./PrintFooter.vue?vue&type=style&index=0&id=3faf51e6&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "3faf51e6",
  "7efe1153"
  
)

export default component.exports